"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arrayContains;
/**
 * Check if an array contains a specified item
 *
 * @param {Array} array The array to check for the item
 * @param {*} item The item to look for in the array
 * @returns {boolean} Returns true when the item is found, otherwise false
 */
function arrayContains(array, item) {
  return Array.prototype.indexOf.call(array, item) !== -1;
}
//# sourceMappingURL=arrayContains.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/~/d2-utilizr/lib/arrayContains.js
 ** module id = 4
 ** module chunks = 0 1
 **/